import { observer } from 'mobx-react-lite'
import { useParams } from 'react-router'
import { uiStore } from 'shared/store/uiStore'
import { EnumAccessPageKeys } from 'entities/ExportRouters/lib/checkAccessPage'
import { AccessLayout } from 'entities/ExportRouters'
import { InboxesRoutes } from 'pages/settings/pages/inboxes/route/type'
import { InboxesPath } from 'pages/settings/pages/inboxes/route/inboxesPath'

export const InboxPageAiAutomationAccessLayout = observer(() => {
  const { id } = useParams()

  return (
    <AccessLayout
      name={EnumAccessPageKeys.chatbot}
      isDisableContent
      onAccessDenied={() => {
        uiStore.changeRouteViaVue({
          method: 'replace',
          path: `/${InboxesPath.rootV1}/${id}/${InboxesRoutes.settings}/${InboxesRoutes.messaging}/${InboxesRoutes.general}`,
        })
      }}
    />
  )
})
